var React = require('react');

function Electronics (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 1v2h2V1H7zm4 0v2h2V1h-2zm4 0v2h2V1h-2zM7 5c-1.093 0-2 .907-2 2v10c0 1.093.907 2 2 2h10c1.093 0 2-.907 2-2V7c0-1.093-.907-2-2-2H7zM1 7v2h2V7H1zm6 0h10v10H7V7zm14 0v2h2V7h-2zM9 9v1 5h6V9H9zm-8 2v2h2v-2H1zm10 0h2v2h-2v-2zm10 0v2h2v-2h-2zM1 15v2h2v-2H1zm20 0v2h2v-2h-2zM7 21v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z"}));
}

Electronics.defaultProps = {"viewBox":"0 0 24 24","xmlnsV":"https://vecta.io/nano"};

module.exports = Electronics;

Electronics.default = Electronics;
